import { getAuthToken } from "./GlobalApi";
import { APIHeader } from "../Helpers";
import { GlobalConstants } from "../components/constants/GlobalConstants";
import { getParsedData } from "../helpers/GlobalHelper";
const url = process.env.REACT_APP_API_URL;

const getProfile = async (proxyUserId = undefined) => {
  const suffix = "user/profile";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers,
  });
};

const deleteProfileAvatar = async (assetId, proxyUserId = undefined) => {
  const suffix = "user/delete-avatar";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${assetId}`, {
    method: "DELETE",
    headers: headers,
  });
};

const deleteBrokerLogo = async (assetId, proxyUserId = undefined) => {
  const suffix = "user/delete-logo";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${assetId}`, {
    method: "DELETE",
    headers: headers,
  });
};

const getProfilenMetadata = async (proxyUserId = undefined) => {
  const suffix = "user/metadata";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const createProfile = async (profile, proxyUserId = undefined) => {
  const suffix = "user/create-profile";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(profile)
  });
};

const updateProfile = async (profile, proxyUserId = undefined) => {
  const suffix = "user/update-profile";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(profile)
  });
};

const getProfileAsset = async (id, proxyUserId = undefined) => {
  const suffix = `user/asset/${id}`;
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Authorization": `Bearer ${await getAuthToken()}`
  };
  if (proxyUserId) {
    headers["impersonatedUserId"] = proxyUserId;
  }
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers,
  });
};

const updateProfileAvatar = async (file, assetId, proxyUserId = undefined) => {
  const formData = new FormData();
  formData.append("Id", assetId);
  formData.append("AssetFile", file, file.name);
  const suffix = "user/create-avatar";
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Authorization": `Bearer ${await getAuthToken()}`
  };
  if (proxyUserId) {
    headers["impersonatedUserId"] = proxyUserId;
  }
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: formData
  });
};

const updateBrokerLogo = async (file, assetId, proxyUserId = undefined) => {
  const formData = new FormData();
  formData.append("Id", assetId);
  formData.append("AssetFile", file, file.name);
  const suffix = "user/create-logo";
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Authorization": `Bearer ${await getAuthToken()}`
  };
  if (proxyUserId) {
    headers["impersonatedUserId"] = proxyUserId;
  }
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: formData
  });
};

const getDashboard = async (proxyUserId = undefined) => {
  const suffix = "dashboard/info";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getGMRInfoList = async (proxyUserId = undefined) => {
  const suffix = "gmr/infolist";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getLoanInfoList = async (proxyUserId = undefined, brokerageOrganizationid = undefined) => {
  let suffix = "loans/infolist";
  if (brokerageOrganizationid) {
    suffix = `loans/infolist/${brokerageOrganizationid}`;
  }
  
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getGMRSummary = async (id, proxyUserId = undefined) => {
  const suffix = "gmr/info/";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}${id}`, {
    method: "GET",
    headers: headers
  });
};

const getGMRMetadata = async (proxyUserId = undefined, isAnonymous = false) => {
  const suffix = "gmr/metadata";
  const headers = APIHeader(proxyUserId, await getAuthToken()) as any;
  if (isAnonymous) {
    headers.email = "public@builderscapital.serviceyourloan.com";
  }

  return await fetch(`${url}${suffix}${isAnonymous ? "/public" : ""}`, {
    method: "GET",
    headers: headers
  });
};

const getAssociatedBorrowers = async (organizationContactId, proxyUserId = undefined) => {
  const suffix = "user/borrowers";
  const headers = APIHeader(proxyUserId, await getAuthToken()) as any;
  return await fetch(`${url}${suffix}/${organizationContactId ?? ""}`, {
    method: "GET",
    headers: headers
  });
};

const getAllBorrowers = async (proxyUserId = undefined) => {
  const suffix = "user/borrowers/all";
  const headers = APIHeader(proxyUserId, await getAuthToken()) as any;
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getAllBrokers = async (proxyUserId = undefined) => {
  const suffix = "user/brokers/all";
  const headers = APIHeader(proxyUserId, await getAuthToken()) as any;
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const calculateGMR = async (gmr, proxyUserId = undefined, isAnonymous = false) => {
  const suffix = "gmr/calculate";
  const headers = APIHeader(proxyUserId, await getAuthToken()) as any;
  if (isAnonymous) {
    headers.email = gmr.email;
  }

  return await fetch(`${url}${suffix}${isAnonymous ? "/public" : ""}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(gmr)
  });
};

const recalculateGMR = async (gmr, proxyUserId = undefined) => {
  const suffix = "gmr/add-scenarios";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(gmr)
  });
};

const submitGMR = async (id, proxyUserId = undefined) => {
  const suffix = "gmr/submit";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${id}`, {
    method: "PUT",
    headers: headers
  });
};

const submitMVPGMR = async (gmr, proxyUserId = undefined) => {
  const suffix = "gmr/upsert";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(gmr)
  });
};

const getApplicationConfig = async (proxyUserId = undefined) => {
    const suffix = "borrowerapplication/config";
    const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getApplicationMetadata = async (proxyUserId = undefined) => {
  const suffix = "borrowerapplication/metadata";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getBuilders = async (id, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/builders";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${id}`, {
    method: "GET",
    headers: headers
  });
};

const createBuilder = async (newBorrowerEntity, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/create-builder";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(newBorrowerEntity)
  });
};

const getApplicationSummary = async (id, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/summary/";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}${id}`, {
    method: "GET",
    headers: headers
  });
};

const getBorrowerEntities = async (id, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/borrower-entities";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${id}`, {
    method: "GET",
    headers: headers
  });
};

const upsertBorrowerEntity = async (newBorrowerEntity, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/upsert-borrower-entity";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(newBorrowerEntity)
  });
};

const upsertGuarantor = async (newGuarantor, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/upsert-guarantor";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(newGuarantor)
  });
};

const deleteGuarantor = async (guarantorObj, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/delete-guarantor";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "DELETE",
    headers: headers,
    body: JSON.stringify(guarantorObj)
  });
};

const getApplicationInfoList = async (proxyUserId = undefined, brokerageOrganizationid = undefined) => {
    let suffix = "borrowerapplication/infolist";
    if (brokerageOrganizationid) {
      suffix = `borrowerapplication/infolist/${brokerageOrganizationid}`;
    }

    const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const getLoanSummary = async (id, proxyUserId = undefined) => {
  const suffix = "loans/summary/";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}${id}`, {
    method: "GET",
    headers: headers
  });
};

const getW9Url = async (proxyUserId = undefined, appReturnUrl ) => {
  const suffix = "esign/w9/generate";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}?appReturnUrl=${appReturnUrl}`, {
    method: "GET",
    headers: headers
  });
};

const download = async (documentMasterId, proxyUserId = undefined) => {
  const suffix = "esign/download/";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}${documentMasterId}`, {
    method: "GET",
    headers: headers
  });
};

const sendLoanApplication = async (sendApplicationInfo, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/invite-borrower";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(sendApplicationInfo)
  });
};

const exportGMRQuote = async (id, proxyUserId = undefined) => {
  const suffix = "gmr/export";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${id}`, {
    method: "GET",
    headers: headers
  });
};

const upsertBorrowerApplication = async (newGuarantor, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/upsert-entire";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(newGuarantor)
  });
};

const getBorrowerApplicationInfo = async (id, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/info";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${id}`, {
    method: "GET",
    headers: headers
  });
};

const getLoanInfo = async (id, proxyUserId = undefined) => {
  const suffix = "loans/info";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${id}`, {
    method: "GET",
    headers: headers
  });
};

const sendGMRStartEmail = async (emailObj, proxyUserId = undefined) => {
  const suffix = "gmr/start-email";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(emailObj)
  });
};

const sendApplicationStartEmail = async (emailObj, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/start-email";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(emailObj)
  });
};

const getBorrowerEntity = async (borrowerApplicationId, borrowerOrganizationId, proxyUserId = undefined) => {
  const borrowerObj = {
    borrowerApplicationId: borrowerApplicationId,
    borrowerOrganizationId: borrowerOrganizationId
  };

  const suffix = "borrowerapplication/borrower/get";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(borrowerObj)
  });
};

const getGuarantor = async (guarantorObj, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/guarantor/get";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(guarantorObj)
  });
};

const createSubdomainUrl = async (subdomain, proxyUserId = undefined) => {
  const suffix = "user/create-subdomain/";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}${subdomain}`, {
    method: "PUT",
    headers: headers
  });
};

const getDisclosure = async (appReturnUrl, applicationId, proxyUserId = undefined) => {
  const suffix = "esign/disclosure/generate";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${applicationId}?appReturnUrl=${appReturnUrl}`, {
    method: "GET",
    headers: headers
  });
};

const getApplicationCopy = async (copyObject, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/copy-borrower-application";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(copyObject)
  });
};

const downloadLoanDocument = async (documentId, proxyUserId = undefined) => {
  const suffix = "document/download";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${documentId}`, {
    method: "GET",
    headers: headers
  });
};

const getLoanDocuments = async (loanId, proxyUserId = undefined) => {
  const suffix = "document/infolist";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${loanId}`, {
    method: "GET",
    headers: headers
  });
};

const getLoanDocumentsMetadata = async (proxyUserId = undefined) => {
  const suffix = "document/metadata";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const deleteLoanDocument = async (documentId, proxyUserId = undefined) => {
  const suffix = "document/delete";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${documentId}`, {
    method: "DELETE",
    headers: headers
  });
};

const updateLoanDocument = async (documentObj, proxyUserId = undefined) => {
  const suffix = "document/update";
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Authorization": `Bearer ${await getAuthToken()}`
  };

  if (proxyUserId) {
    headers["impersonatedUserId"] = proxyUserId;
  }
  
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: getParsedData(documentObj, "FormData")
  });
};

const createLoanDocument = async (file, documentObj, proxyUserId = undefined) => {
  const formData = new FormData();
  formData.append("AssetFile", file, file.name);
  formData.append("Id", documentObj.id);
  formData.append("BorrowerApplicationId", documentObj.borrowerApplicationId);
  formData.append("DocumentMasterId", documentObj.documentMasterId);
  formData.append("Description", documentObj.description);
  const suffix = "document/create";
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Authorization": `Bearer ${await getAuthToken()}`
  };
  if (proxyUserId) {
    headers["impersonatedUserId"] = proxyUserId;
  }
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: formData
  });
};

const getGuarantors = async (applicationId, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/guarantors";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${applicationId}`, {
    method: "GET",
    headers: headers
  });
};

const resendGuarantorInvite = async (guarantorInviteObj, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/invite-guarantor-email";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(guarantorInviteObj)
  });
};

const calculateGmrFromApplication = async (borrowerApplication, proxyUserId = undefined) => {
  const suffix = "gmr/calculate-from-borrowerapplication";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(borrowerApplication)
  });
};

const saveLoanDetails = async (applicationId, loanDetails, proxyUserId = undefined) => {
  const suffix = "loandetails/set/";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}${applicationId}`, {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(loanDetails)
  });
};

const patchLoanProjectSection = async (applicationId, projectPatchObj, proxyUserId = undefined) => {
  const suffix = "loans/project";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${applicationId}`, {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(projectPatchObj)
  });
};

const patchLoanProperties = async (propertiesPatchArr, proxyUserId = undefined, insert = false) => {
  const suffix = "loans/properties";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: insert ? "POST" : "PATCH",
    headers: headers,
    body: JSON.stringify(propertiesPatchArr)
  });
};

const postLoanReoSchedules  = async (
  loanId: string,
  newReoSchedules: any[], 
  proxyUserId?: string,
) => {
  const suffix = `loans/reo-schedules/${loanId}`;
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(newReoSchedules)
  });
};

const patchLoanReoSchedules  = async (
  updatedReoSchedules: any[], 
  proxyUserId?: string,
) => {
  const suffix = "loans/reoschedule";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(updatedReoSchedules)
  });
};

const patchLoanBorrowerSection = async (patchObj, proxyUserId = undefined) => {
  const suffix = "loans/borrower";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(patchObj)
  });
};

const patchLoanGuarantorSection = async (orgContactId, patchObj, proxyUserId = undefined) => {
  const suffix = "loans/guarantor-section";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${orgContactId}`, {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(patchObj)
  });
};

const addBorrowerGuarantors = async (applicationId, invitedGuarantors, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/borrower-add-guarantors";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${applicationId}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(invitedGuarantors)
  });
};

const deleteSubdomain = async (subdomain, proxyUserId) => {
  const suffix = "user/subdomain";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${subdomain}`, {
    method: "DELETE",
    headers: headers
  });
};

const addLoanUnits = async (units, proxyUserId = undefined) => {
  const suffix = "loans/property-units";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(units)
  });
};

const getGuarantorExists = async (email, proxyUserId) => {
  const suffix = "borrowerapplication/guarantor-email";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify({ email: email })
  });
};

const pullCreditScore = async (creditUser, proxyUserId) => {
  const suffix = "credit/pull-score";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(creditUser)
  });
};


const deleteLoanProperty = async (propertyId, proxyUserId = undefined) => {
  const suffix = "loans/property";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${propertyId}`, {
    method: "DELETE",
    headers: headers,
    body: JSON.stringify(propertyId)
  });
};

const deleteLoanUnit = async (unitId, proxyUserId = undefined) => {
  const suffix = "loans/delete-unit";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${unitId}`, {
    method: "DELETE",
    headers: headers
  });
};

const getBrokerGuarantors = async (borrowerOrganizationId, applicationId, proxyUserId) => {
  const suffix = "borrowerapplication/broker-guarantors";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${borrowerOrganizationId}/${applicationId}`, {
    method: "GET",
    headers: headers
  });
};

const getGuarantorGuarantors = async (borrowerOrganizationId, proxyUserId) => {
  const suffix = "borrowerapplication/guarantor-guarantors";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${borrowerOrganizationId}`, {
    method: "GET",
    headers: headers
  });
};

const deleteLoanCostsPaids = async (costPaidId, proxyUserId = undefined) => {
  const suffix = "loans/delete-cost-paid";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${costPaidId}`, {
    method: "DELETE",
    headers: headers,
    body: JSON.stringify(costPaidId)
  });
};

const addLoanALSchedule = async (data, proxyUserId = undefined) => {
  const suffix = "loans/create-alschedules";  
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(data)
  });
};

const deleteLoanALSchedules = async (Id, proxyUserId = undefined) => {
  const suffix = "loans/delete-alschedule";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${Id}`, {
    method: "DELETE",
    headers: headers
  });
};

const addLoanREO = async (data, proxyUserId = undefined) => {
  const suffix = "loans/create-reo-schedules";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(data)
  });
};

const deleteLoanREO = async (Id, proxyUserId = undefined) => {
  const suffix = "loans/delete-reoschedule";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${Id}`, {
    method: "DELETE",
    headers: headers
  });
};

const getGmrScenarios = async (scenarios, proxyUserId = undefined) => {
  const suffix = "gmr/gmrs";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(scenarios)
  });
};

const exportGMRQuotes = async (scenarios, proxyUserId = undefined) => {
  const suffix = "gmr/quotes-pdf";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(scenarios)
  });
};

const isProjectNameExists = async (projectName, Id, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/project-name-exists";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${Id}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(projectName)
  });
};

const declineGuarantorInvitation = async (declineId, declineObj, proxyUserId = undefined) => {
  let suffix = "borrowerapplication/guarantor/decline";
  if (declineId) {
    suffix = "borrowerapplication/guarantor/decline-from-email";
  }

  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}${declineId ? `?declineId=${declineId}` : ""}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(declineObj)
  });
};

const acceptGuarantorInvitation = async (declineObj, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/guarantor/accept";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(declineObj)
  });
};

const getGuarantorDeclineReason = async (borrowerApplicationId, email, declineId, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/guarantor/decline-reasons";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}?borrowerApplicationId=${borrowerApplicationId}&email=${email}&declineId=${declineId}`, {
    method: "GET",
    headers: headers
  });
};

const getBrokerBuilder = async (builderOrganizationId, proxyUserId) => {
  const suffix = "borrowerapplication/builder";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${builderOrganizationId}`, {
    method: "GET",
    headers: headers
  });
};

const submitBorrowerApplication = async (submitObj, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/upsert-submit-application";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(submitObj)
  });
};

const patchBorrowerApplicationProjectSection = async (patchObj, isUpsert, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/project";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}${isUpsert ? "/true": ""}`, {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(patchObj)
  });
};

const patchBorrowerApplicationProperties = async (patchObj, isUpsert, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/properties-and-property-units";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}${isUpsert ? "/true": ""}`, {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(patchObj)
  });
};

const patchBorrowerApplicationPlans = async (patchObj, isUpsert, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/plans";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}${isUpsert ? "/true": ""}`, {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(patchObj)
  });
};

const patchBorrowerApplicationCostsPaids = async (applicationId, patchObj, isUpsert, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/cost-paids";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${applicationId}${isUpsert ? "/true": ""}`, {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(patchObj)
  });
};

const deleteBorrowerApplicationCostsPaids = async (deleteIds, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/delete-cost-paids";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "DELETE",
    headers: headers,
    body: JSON.stringify(deleteIds)
  });
};

const deleteBorrowerApplicationPlans = async (deleteIds, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/delete-plans";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "DELETE",
    headers: headers,
    body: JSON.stringify(deleteIds)
  });
};

const deleteBorrowerApplicationPropertiesAndUnits = async (deleteIds, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/delete-properties";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "DELETE",
    headers: headers,
    body: JSON.stringify(deleteIds)
  });
};

const deleteBorrowerApplicationUnits = async (deleteIds, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/delete-property-units";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "DELETE",
    headers: headers,
    body: JSON.stringify(deleteIds)
  });
};

const deleteGuarantorALSchedule = async (alscheduleId, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/delete-alschedule";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${alscheduleId}`, {
    method: "DELETE",
    headers: headers
  });
};

const updateGmrStatus = async (gmrObj, proxyUserId = undefined) => {
  const suffix = "gmr/update-status";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(gmrObj)
  });
};

const sendApplicationToPrescreener = async (applicationId, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/sent-to-prescreener";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${applicationId}`, {
    method: "POST",
    headers: headers
  });
};

const requestApplicationRevision = async (applicationId, revisionObj, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/revision-request";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${applicationId}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(revisionObj)
  });
};

const submitApplicationForReview = async (applicationId, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/submit-for-review";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${applicationId}`, {
    method: "POST",
    headers: headers
  });
};

const getPayeezyLoanInvoices = async (loanId, proxyUserId) => {
  const suffix = "onlinepayment/loan/invoices";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}?loanId=${loanId}`, {
    method: "GET",
    headers: headers
  });
};

const getPayeezyPaymentPage = async (invoiceId, proxyUserId) => {
  const suffix = "onlinepayment/payeezy-paymentpage";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${invoiceId}`, {
    method: "GET",
    headers: headers
  });
};

const downloadPayeezyInvoice = async (invoiceId, proxyUserId) => {
  const suffix = "onlinepayment/invoice/download";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}?invoiceId=${invoiceId}`, {
    method: "GET",
    headers: headers
  });
};

const getLoanComments = async (loanId, proxyUserId) => {
  const suffix = "loans/comments";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${loanId}`, {
    method: "GET",
    headers: headers
  });
};

const createLoanComment = async (loanCommentObj, proxyUserId = undefined) => {
  const suffix = "loans/create-comment";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(loanCommentObj)
  });
};

const patchLoanComments = async (loanCommentObj, proxyUserId = undefined) => {
  const suffix = "loans/comments";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(loanCommentObj)
  });
};

const getInternalContacts = async (proxyUserId) => {
  const suffix = "user/internal-contacts";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const createDeal = async (dealObj, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/deal";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(dealObj)
  });
};

const getBrokerEmailExists = async (email, proxyUserId) => {
  const suffix = "user/broker-email";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify({email: email})
  });
};

const createNewBroker = async (brokerObj, proxyUserId = undefined) => {
  const suffix = "user/create-broker";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(brokerObj)
  });
};

const getSimilarBrokerageNameList = async (name, proxyUserId, isAnonymous = false) => {
  const suffix = `borrowerapplication/brokerage-fuzzylist${isAnonymous ? "-anonymous" : ""}`;
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${name}?topNumber=5`, {
    method: "GET",
    headers: headers,
  });
};

const sendEmailToBroker = async (brokerEmailObj, proxyUserId = undefined) => {
  const suffix = "gmr/sendemail-to-broker";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(brokerEmailObj)
  });
};

const getGmrBorrowers = async (proxyUserId = undefined) => {
  const suffix = "gmr/user-context/borrowers";
  const headers = APIHeader(proxyUserId, await getAuthToken()) as any;
  return await fetch(`${url}${suffix}`, {
    method: "GET",
    headers: headers
  });
};

const patchBorrowerApplicationEntities = async (patchObj, isUpsert, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/entities";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: isUpsert ? "POST" : "PATCH",
    headers: headers,
    body: JSON.stringify(patchObj)
  });
};

const getBorrowerApplicationEntities = async (applicationId, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/list-entity";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${applicationId}`, {
    method: "GET",
    headers: headers
  });
};

const downloadPropertyUnitExcel = async (borrowerApplicationId, numberOfProperties, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/export-property-workbook";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}/${borrowerApplicationId}?numberOfProperties=${numberOfProperties}`, {
    method: "GET",
    headers: headers
  });
};

const importPropertyUnitExcel = async (file, borrowerApplicationId, proxyUserId = undefined, forceUpdate) => {
  const formData = new FormData();
  formData.append("AssetFile", file, file.name);
  formData.append("BorrowerApplicationId", borrowerApplicationId);
  formData.append("DocumentMasterId", GlobalConstants.DocumentMaster.PROPERTY_WORKBOOK);
  formData.append("forceUpdate", forceUpdate);
  const suffix = "borrowerapplication/import-property-workbook";
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Authorization": `Bearer ${await getAuthToken()}`
  };
  if (proxyUserId) {
    headers["impersonatedUserId"] = proxyUserId;
  }
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: formData
  });
};

const getBorrowerApplicationGuarantorSigned = async (borrowerApplicationId, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/guarantor-signed";
  const headers = APIHeader(proxyUserId, await getAuthToken()) as any;
  return await fetch(`${url}${suffix}/${borrowerApplicationId}`, {
    method: "GET",
    headers: headers
  });
};

const submitAnonymousGmr = async (gmr, proxyUserId = undefined) => {
  const suffix = "gmr/submit/public";
  const headers = APIHeader(proxyUserId, await getAuthToken()) as any;
  headers.email = gmr.email;

  return await fetch(`${url}${suffix}?guid=${gmr.id}`, {
    method: "POST",
    headers: headers
  });
};

const exportWorkbookFromGmr = async (gmrId, proxyUserId = undefined) => {
  const suffix = "gmr/export";
  const headers = APIHeader(proxyUserId, await getAuthToken()) as any;
  return await fetch(`${url}${suffix}/${gmrId}`, {
    method: "GET",
    headers: headers
  });
};

const exportWorkbookFromApplication = async (gmrId, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/export";
  const headers = APIHeader(proxyUserId, await getAuthToken()) as any;
  return await fetch(`${url}${suffix}/${gmrId}`, {
    method: "GET",
    headers: headers
  });
};

const notifyLoanOfficer = async (loanOfficerEmailObj, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/loanofficer-email";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(loanOfficerEmailObj)
  });
};

const createBorrowerApplicationGuarantors = async (guarantors, proxyUserId = undefined) => {
  const suffix = "borrowerapplication/guarantors";
  const headers = APIHeader(proxyUserId, await getAuthToken());
  return await fetch(`${url}${suffix}`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(guarantors)
  });
};

export {
  getProfile,
  deleteProfileAvatar,
  deleteBrokerLogo,
  getProfilenMetadata,
  createProfile,
  updateProfile,
  getProfileAsset,
  updateProfileAvatar,
  updateBrokerLogo,
  getDashboard,
  getGMRInfoList,
  getApplicationInfoList,
  getLoanInfoList,
  getGMRSummary,
  getGMRMetadata,
  getAssociatedBorrowers,
  getAllBorrowers,
  getAllBrokers,
  calculateGMR,
  submitGMR,
  submitMVPGMR,
  getApplicationConfig,
  getApplicationMetadata,
  getBuilders,
  createBuilder,
  getApplicationSummary,
  getLoanSummary,
  getBorrowerEntities,
  upsertBorrowerEntity,
  postLoanReoSchedules,
  patchLoanReoSchedules,
  getGuarantors,
  upsertGuarantor,
  deleteGuarantor,
  getW9Url,
  download,
  sendLoanApplication,
  exportGMRQuote,
  upsertBorrowerApplication,
  getBorrowerApplicationInfo,
  sendGMRStartEmail,
  sendApplicationStartEmail,
  getBorrowerEntity,
  getGuarantor,
  createSubdomainUrl,
  getDisclosure,
  getApplicationCopy,
  getLoanDocuments,
  downloadLoanDocument,
  getLoanDocumentsMetadata,
  deleteLoanDocument,
  updateLoanDocument,
  createLoanDocument,
  resendGuarantorInvite,
  calculateGmrFromApplication,
  saveLoanDetails,
  patchLoanProjectSection,
  patchLoanBorrowerSection,
  patchLoanProperties,
  patchLoanGuarantorSection,
  addBorrowerGuarantors,
  getLoanInfo,
  deleteSubdomain,
  addLoanUnits,
  deleteLoanProperty,
  deleteLoanUnit,
  deleteLoanCostsPaids,
  addLoanALSchedule,
  deleteLoanALSchedules,
  addLoanREO,
  deleteLoanREO,
  getBrokerGuarantors,
  getGuarantorGuarantors,
  getGuarantorExists,
  pullCreditScore,
  getGmrScenarios,
  exportGMRQuotes,
  isProjectNameExists,
  declineGuarantorInvitation,
  acceptGuarantorInvitation,
  getGuarantorDeclineReason,
  getBrokerBuilder,
  recalculateGMR,
  submitBorrowerApplication,
  patchBorrowerApplicationProjectSection,
  patchBorrowerApplicationProperties,
  patchBorrowerApplicationPlans,
  patchBorrowerApplicationCostsPaids,
  deleteBorrowerApplicationCostsPaids,
  deleteBorrowerApplicationPlans,
  deleteBorrowerApplicationPropertiesAndUnits,
  deleteBorrowerApplicationUnits,
  deleteGuarantorALSchedule,
  updateGmrStatus,
  sendApplicationToPrescreener,
  requestApplicationRevision,
  submitApplicationForReview,
  getPayeezyLoanInvoices,
  getPayeezyPaymentPage,
  downloadPayeezyInvoice,
  getLoanComments,
  createLoanComment,
  patchLoanComments,
  getInternalContacts,
  createDeal,
  getBrokerEmailExists,
  createNewBroker,
  getSimilarBrokerageNameList,
  sendEmailToBroker,
  getGmrBorrowers,
  patchBorrowerApplicationEntities,
  getBorrowerApplicationEntities,
  downloadPropertyUnitExcel,
  importPropertyUnitExcel,
  getBorrowerApplicationGuarantorSigned,
  submitAnonymousGmr,
  exportWorkbookFromGmr,
  exportWorkbookFromApplication,
  notifyLoanOfficer,
  createBorrowerApplicationGuarantors
};